import TableToolbar from "@rio-cloud/rio-uikit/TableToolbar";
import ToolbarActions, { type ToolbarActionsProps } from "../ToolbarActions";
import ToolbarSearch from "../ToolbarSearch";

export type { ColumnDetails, ColumnDetailsMap, ColumnLabel } from "../toolbarTypes";

interface Props extends ToolbarActionsProps {
  searchValue: string;
  handleSearchValueChange: (newSearchValue: string) => void;
}

const Toolbar = ({ searchValue, handleSearchValueChange, ...actions }: Props) => (
  <TableToolbar>
    <div className="table-toolbar-container">
      <div className="table-toolbar-group-left">
        <div className="table-toolbar-column display-flex flex-row gap-10 align-items-center">
          <ToolbarSearch searchValue={searchValue} handleSearchValueChange={handleSearchValueChange} />
        </div>
      </div>

      <ToolbarActions {...actions} />
    </div>
  </TableToolbar>
);

export default Toolbar;
